import { render } from "./ItemAnalytics.vue?vue&type=template&id=9c6ce92a&scoped=true"
import script from "./ItemAnalytics.vue?vue&type=script&lang=js"
export * from "./ItemAnalytics.vue?vue&type=script&lang=js"

import "./ItemAnalytics.vue?vue&type=style&index=0&id=9c6ce92a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c6ce92a"]])

export default __exports__